import { useEffect, useState } from "react";
import PortalLayout from "@/components/PortalLayout";
import { api, BACKEND_URL } from "@/lib/api";
import { usePortalAuth } from "@/context/PortalAuth";
import { AlertTriangle } from "lucide-react";
import { sanitizeHtml } from "@/lib/sanitize";
import { ReplyButton } from "@/components/ReplyThread";

export default function PortalNotices() {
  const [rows, setRows] = useState([]);
  const { me } = usePortalAuth();
  useEffect(() => { api.get("/portal/notices").then(({ data }) => setRows(data)); }, []);
  const broadcast = rows.filter((n) => n.category === "Broadcast");
  const regular = rows.filter((n) => n.category !== "Broadcast");
  return (
    <PortalLayout subtitle="Communications" title="Notices">
      {broadcast.map((n) => (
        <div key={n.id} className="mb-4 rounded-2xl border-2 border-terracotta bg-terracotta/5 p-5 flex items-start gap-3">
          <AlertTriangle className="text-terracotta mt-0.5" size={20}/>
          <div>
            <div className="text-xs uppercase tracking-widest text-terracotta font-semibold">Broadcast · {n.issued_at?.slice(0, 10)}</div>
            <div className="editorial text-xl mt-1">{n.title}</div>
            <div className="text-sm text-stone-700 mt-2 prose prose-sm max-w-none" dangerouslySetInnerHTML={{ __html: sanitizeHtml(n.body) }} />
          </div>
        </div>
      ))}
      <div className="space-y-3">
        {regular.map((n) => (
          <div key={n.id} className="bg-white border border-stone-200 rounded-2xl p-5" data-testid={`notice-${n.id}`}>
            <div className="flex items-center justify-between">
              <div>
                <div className="text-xs uppercase tracking-widest text-terracotta font-semibold">{n.category}</div>
                <div className="editorial text-xl mt-1">{n.title}</div>
                <div className="text-xs text-stone-500 mt-1">{n.issued_at?.slice(0, 16).replace("T", " ")}</div>
              </div>
              <a href={`${BACKEND_URL}/api/tenants/${me?.society?.id}/notices/${n.id}/pdf`} target="_blank" rel="noreferrer"
                className="text-terracotta text-sm font-medium">PDF ↗</a>
            </div>
            <div className="text-sm text-stone-600 mt-3 prose prose-sm max-w-none" dangerouslySetInnerHTML={{ __html: sanitizeHtml(n.body) }} />
            <div className="mt-3 flex justify-end">
              <ReplyButton entityType="notice" entityId={n.id} entityTitle={n.title} testid={`reply-notice-${n.id}`}/>
            </div>
          </div>
        ))}
        {regular.length === 0 && broadcast.length === 0 && <div className="bg-white border border-stone-200 rounded-2xl p-10 text-center text-stone-500">No notices yet.</div>}
      </div>
    </PortalLayout>
  );
}
